import config from '../../config/config';
import {
  StationParameters,
  StationStatusChangeParameters,
} from '../../interface/charging-station.interface';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the charging station list with pagination
   */
  fetchChargingStations: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-station`, {
      ...parameters,
    });
  },
  /**
   * Fetch the charging station list with pagination
   */
  fetchChargingStationsListFilters: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-station/list-filters`);
  },
  /**
   * Fetch charging station by Id
   * @param id
   * @returns
   */
  fetchChargingStationById: (id: string): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-station/${id}`);
  },
  /**
   * Fetch the charging station list with pagination
   */
  exportChargingStations: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-station/export-data`, {
      ...parameters,
    });
  },
  /**
   * Create the station api call function
   * @param data
   * @returns
   */
  createChargingStation: (
    data: StationParameters = {
      name: '',
      email: '',
      role: '',
      password: '',
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.commonApiUrl}api/super-admin/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Update the station api call function
   * @param data
   * @returns
   */
  editChargingStation: (
    id: string,
    data: StationParameters = {
      name: '',
      email: '',
      role: '',
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.commonApiUrl}api/super-admin/v1/users/${id}`, {
      ...parameters,
    });
  },
  /**
   * Delete the station api call function
   * @param data
   * @returns
   */
  deleteChargingStation: (id: String): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/super-admin/v1/users/${id}`);
  },
  /**
   * Delete the station api call function
   * @param data
   * @returns
   */
  statusChangeChargingStation: (id: string, data: StationStatusChangeParameters): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.commonApiUrl}api/super-admin/v1/charging-station/${id}`, {
      ...parameters,
    });
  },
  /**
   * Fetch the charging station list with pagination
   */
  fetchChargingPointByStationId: (id: string): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-point/charging-station/${id}`,
    );
  },

  /**
   *  pending notification count
   * @returns
   */
  fetchPendingNotificationCount: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-station/pending-count`)
  },
    /**
   * Delete the device status
   */
  deleteDeviceStatus: (id: string): Promise<any> => {
    return deleteRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-station/cancel-schedule-delete-station/${id}`,
    );
  },
  /**
   * Get method The station you are deleting has active charging point
   */
  getStationDeletionCheck: (id: string): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-station/deletion-check/${id}`
    );
  },
};
